import immutableStore from 'utils/immutableStore';
import {Map, List, Record} from 'immutable';
import alt from 'components/Dispatcher';
import UpcomingReviewsActions from 'actions/coaching/UpcomingReviewsActions';
import {associateBy} from 'utils/associateBy';

@immutableStore
class UpcomingReviewsStore {
  constructor() {
    this.state = Record({
      upcomingReviews: List(),
      upcomingReviewsLoading: false,
      upcomingReviewsError: false,
      // Map<UserId, Map<ReviewId, UpcomingReview>>
      upcomingReviewsMap: Map(),
    })();

    this.bindActions(UpcomingReviewsActions);
  }

  upcomingReviews() {
    this.setState({
      upcomingReviewsLoading: true,
      upcomingReviewsError: false,
    });
  }

  upcomingReviewsSuccess([userId, upcomingReviews]) {
    const reviews = upcomingReviews.sort((a, b) => (a.scheduleAt.isAfter(b.scheduleAt) ? 1 : -1));
    this.setState({
      upcomingReviewsError: false,
      upcomingReviewsLoading: false,
      upcomingReviews,
      upcomingReviewsMap: this.state.upcomingReviewsMap.set(
        userId,
        associateBy(reviews, r => r.id)
      ),
    });
  }

  upcomingReviewsError() {
    this.setState({
      upcomingReviews: List(),
      upcomingReviewsLoading: false,
      upcomingReviewsError: true,
    });
  }

  sendReminderSuccess([userId, review]) {
    this.setState({
      upcomingReviewsMap: this.state.upcomingReviewsMap.update(userId, (reviews = Map()) =>
        reviews.set(review.id, review)
      ),
    });
  }
}

export default alt.createStore(UpcomingReviewsStore, 'UpcomingReviewsStore');
